import * as boardingSheetTypes from './boarding-sheet.types';

export const setStateBoardingSheetReducer = (prop, value) => (dispatch) => {
	dispatch({ type: boardingSheetTypes.SET_BOARDING_SHEET, payload: { prop, value } });
};